import React from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@/uiKit/atoms/Button.tsx";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";

export const Terms: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader id="terms-title" title={t("pages.account.terms.title")} />
      <CardContent>
        <Button
          data-action="account.terms.open"
          variant="text"
          target="_blank"
          href="https://steto.notion.site/Conditions-G-n-rales-d-Utilisation-des-Applications-Web-et-Mobiles-St-to-040d5c1ab33544cf90cdbe121e3587cc"
          id="terms-link"
        >
          {t("pages.account.terms.title")}
        </Button>
      </CardContent>
      <CardFooter />
    </Card>
  );
};
